<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col">
        <h2>Pouvoir pour l'Assemblée Générale</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-10">
        Je soussigné
        <!-- eslint-disable-next-line prettier/prettier -->
        <span class="font-weight-bold">{{ personName }}</span>, titulaire de 
        <span class="font-weight-bold">{{ generalTantiemes }} tantièmes généraux</span>, agissant en
        qualité de copropriétaire de la copropriété
        <span class="font-weight-bold">{{ building.name }}</span> située au :
      </div>
      <div class="col-2">
        <img
          v-if="qrCodeBase64Image"
          class="position-absolute"
          :src="qrCodeBase64Image"
          alt="QR CODE"
          style="right: 0;"
        />
      </div>
    </div>
    <div class="row mt-4 mb-4">
      <!-- eslint-disable-next-line prettier/prettier -->
      <div class="offset-5 text-br-line font-weight-bold">{{ building.address }}</div>
    </div>
    <div class="row mb-4">
      <div class="col pb-5 border-bottom">
        donne, par le présent, tous pouvoirs à :
      </div>
    </div>
    <div class="row">
      <div class="col pb-5 border-bottom">
        ou à défaut à :
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        À effet :
        <ul>
          <li>
            D'assister à l'Assemblée Générale des Copropriétaires de l'immeuble ci-dessus indiqué,
            convoquée
            <span class="font-weight-bold">
              {{
                $moment(toLocalTime(meeting.date))
                  .locale("fr")
                  .format("[le] DD MMMM YYYY [à] HH[h]mm")
              }}
            </span>
            ;
          </li>
          <li>
            De me représenter et exercer tous les droits que je tiens du règlement de Copropriété et
            de la loi ;
          </li>
          <li>
            De prendre part, en mon nom, à toutes délibérations, discussions et à tous votes, faire
            toutes protestations oppositions, réserves ;
          </li>
          <li>
            D'accepter toutes fonctions et tous mandats, signer toute feuille de présence, ainsi que
            tous procès-verbaux de séance et tous actes relatifs à l'administration des parties
            communes ;
          </li>
          <li>
            De se substituer et généralement faire le nécessaire pour assurer ma représentation à la
            dite Assemblée Générale.
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col">
        Dans la mesure où je ne préciserais pas nommément de mandataire mon pouvoir sera remis au
        Président de séance pour présider ladite Assemblée Générale avec la faculté pour lui de se
        substituer à toute personne de son choix. Ce mandat prendra donc effet après désignation du
        Président de séance. Sera retenu comme pouvoir la dernière personne ayant reçu mon pouvoir.
      </div>
    </div>
    <div class="row d-flex justify-content-between my-5">
      <div class="col-5 border-bottom"><h5>Signature du mandant</h5></div>
      <div class="col-5 border-bottom"><h5>Signature du mandataire</h5></div>
    </div>
    <div class="row">
      <div class="col"><br /><br /></div>
    </div>
    <div class="row d-flex justify-content-between mt-5">
      <div class="col-5 border-top">
        Dater, signer et mettre de sa main la mention « BON POUR POUVOIR »
      </div>
      <div class="col-5 border-top">
        Dater, signer et mettre de sa main la mention « BON POUR ACCEPTATION »
      </div>
    </div>
    <div class="row">
      <div class="col"><br /><br /></div>
    </div>
    <div class="row mt-5">
      <div class="col">
        Rappel : Le syndic ne peut pas représenter un copropriétaire, une même personne pourra
        recevoir plus de {{ building.votes_per_mandate }} mandats de vote si le total des voix dont
        elle dispose n'excède pas {{ building.parts_per_mandate }}% de la totalité des voix du
        Syndicat.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["meeting", "mandate", "building", "qrCodeBase64Image"],
  data() {
    return {
      generalTantiemes: 0,
      personName: "",
    };
  },
  created() {
    this.personName = this.getPersonNameAndGender({}, this.mandate.building_owner);
    this.getTotalTantiemes();
  },
  methods: {
    getTotalTantiemes() {
      let tantiemes = 0;
      for (const bl of this.mandate.building_owner.building_owner_building_lots) {
        for (const bovr of bl.building_owner_voting_rights) {
          if (bovr.voting_category && bovr.voting_category.is_charge_generale)
            tantiemes += bovr.parts;
        }
      }
      this.generalTantiemes = this.formatNumber(tantiemes);
    },
  },
};
</script>
